import React, { FC } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const OverridenTooltip: FC<{ children: React.ReactNode }> = ({ children }) => (
  <Tooltip title="This price has been overriden in the pricing sidebar" placement="top">
    {children}
    <InfoCircleOutlined style={{ marginLeft: 5 }} />
  </Tooltip>
);
